<div [ngClass]="{ centerContextMenuContainer: centerContextMenu }">
  <div class="content-box">
    <div [ngClass]="{ centerView: useCenterView }">
      <ng-content></ng-content>
    </div>
  </div>
</div>
